import { STATUS_CODE } from '@kc-console/core';
import { RegionUnsupported, ServiceNotFound, TemporaryError } from '@kc-console/shared-ui';

import { WithGnbErrorLayout } from './WithGnbErrorLayout';

import type { StatusCode } from '@kc-console/core';

type WithGnbErrorMapperProps = {
  status: StatusCode;
};

/**
 * GNB 포함 에러 매퍼 컴포넌트
 *
 * @description
 * 상태 코드에 따라 적절한 GNB 포함 에러 컴포넌트를 렌더링합니다.
 * WithGnbErrorLayout으로 감싸서 표시됩니다.
 */
const WithGnbErrorMapper = ({ status }: WithGnbErrorMapperProps) => {
  const renderError = () => {
    if (status === STATUS_CODE.FORBIDDEN_REGION) {
      return <RegionUnsupported />;
    } else if (status === STATUS_CODE.NOT_FOUND_SERVICE) {
      return <ServiceNotFound />;
    } else if (status === STATUS_CODE.INTERNAL_SERVER_ERROR_WITH_GNB) {
      return <TemporaryError />;
    } else {
      return <TemporaryError />;
    }
  };

  return <WithGnbErrorLayout>{renderError()}</WithGnbErrorLayout>;
};

export default WithGnbErrorMapper;
